import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Analytics tracking function
const trackDownload = (source) => {
    if (typeof gtag !== 'undefined') {
        gtag('event', 'download', {
            event_category: 'APK Download',
            event_label: source,
            value: 1
        });
    }
    console.log(`Download tracked from: ${source}`);
};

// --- SVG Icon Components ---
// Using inline SVGs as we can't import libraries in this environment.

const NotebookIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M2 6h4" /><path d="M2 12h4" /><path d="M2 18h4" /><path d="M6 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2z" />
    </svg>
);

const TerminalIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <polyline points="4 17 10 11 4 5" /><line x1="12" y1="19" x2="20" y2="19" />
    </svg>
);

const SparklesIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="m12 3-1.9 5.8-5.8 1.9 5.8 1.9L12 21l1.9-5.8 5.8-1.9-5.8-1.9L12 3z" /><path d="M5 3v4" /><path d="M19 17v4" /><path d="M3 5h4" /><path d="M17 19h4" />
    </svg>
);

const SearchIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
);

const ExportIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" /><polyline points="16 6 12 2 8 6" /><line x1="12" y1="2" x2="12" y2="15" /></svg>
);

const FileIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" /></svg>
);

const ShieldIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
);

const ChatIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
);

const WarningIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" /><line x1="12" y1="9" x2="12" y2="13" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>
);


const ChevronLeftIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
);

const ChevronRightIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
);

const GithubIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.91 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
    </svg>
);

const PlusIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </svg>
);

const MinusIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M19 13H5v-2h14v2z" />
    </svg>
);

const UpvoteArrowIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4l-6 8h12z" />
    </svg>
);

const ProductHuntIcon = ({ className }) => (
    <svg viewBox="0 0 40 40" className={className} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <circle fill="#DA552F" cx="20" cy="20" r="20" />
            <path d="M15.748 13.125h2.95v13.75h-2.95v-13.75zm5.736 3.203h-3.662v7.342h3.662c2.528 0 4.1-1.63 4.1-3.67 0-2.042-1.572-3.672-4.1-3.672z" fill="#FFF" />
        </g>
    </svg>
);

const GooglePlayIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className={className}>
        <path fill="#32BBFF" d="M325.3 234.3L58.2 4.6C53.7 1 48.7 0 44 0c-10.2 0-20 6.7-20 20v472c0 13.3 9.8 20 20 20 4.7 0 9.7-1 14.2-4.6l267.1-229.7 39.8-34.7-39.8-39.7z" />
        <path fill="#FFDF00" d="M44 0c-3.6 0-7.1.8-10.2 2.2l280.8 248.1 50.7-44.2L58.2 4.6C53.7 1 48.7 0 44 0z" />
        <path fill="#E94057" d="M14.2 509.8C17.3 511.2 20.8 512 24.4 512c4.7 0 9.7-1 14.2-4.6l307.1-264.7-50.7-44.2L14 492c.1 6.6 0 13.1.2 17.8z" />
        <path fill="#25D366" d="M471.9 226.5l-77.1-66.4-50.7 44.2 50.7 44.2 77.1-66.2c9.8-8.4 9.8-22.1 0-29.6z" />
    </svg>
);


// --- Animation Variants ---
const sectionVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: "easeOut",
        },
    },
};

const cardVariant = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (i) => ({
        opacity: 1,
        scale: 1,
        transition: {
            delay: i * 0.15,
            duration: 0.5,
            ease: 'easeOut'
        }
    })
};


// --- App Sections ---

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [logoSrc, setLogoSrc] = useState('/logo.png');

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: 'Features', id: 'features' },
        { name: 'About', id: 'about' },
        { name: 'FAQ', id: 'faq' },
    ];

    const scrollToSection = (id) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-black/80 backdrop-blur-lg' : 'bg-black/30'}`}>
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <img src={logoSrc} onError={() => setLogoSrc('/vite.svg')} alt="NoteView logo" className="h-9 w-9 rounded-full bg-white/5 p-1" />
                    <h1 className="text-2xl font-bold text-white tracking-wider">
                        NoteView
                    </h1>
                </div>
                <nav className="hidden md:flex items-center space-x-6">
                    {navLinks.map(link => (
                        <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-gray-300 hover:text-cyan-400 transition-colors duration-300">
                            {link.name}
                        </button>
                    ))}
                </nav>
                <div className="hidden sm:flex items-center gap-3">
                    <a
                        href="https://github.com/Aakhilshaik204/noteviewai/releases/download/NoteView/NoteView.2.0.apk"
                        onClick={() => trackDownload('Header')}
                        className="bg-cyan-500 text-black font-bold py-2 px-5 rounded-lg hover:bg-cyan-400 transition-colors duration-300"
                    >
                        Download
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=ai.noteview.app&hl=en" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-bold py-2 px-5 rounded-lg border border-white/20 bg-white/10 text-white hover:bg-white/20 transition-colors duration-300">
                        <GooglePlayIcon className="h-4 w-4" />
                        Play Store
                    </a>
                </div>
            </div>
        </header>
    );
};

const HeroSection = () => {
    const featuresRef = useRef(null);

    const scrollToFeatures = () => {
        document.getElementById('features').scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className="min-h-screen pt-24 md:pt-32 flex items-center bg-black relative overflow-hidden">
            {/* Background Glows */}
            <div className="absolute top-0 -left-1/4 w-1/2 h-1/2 bg-purple-600/30 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-0 -right-1/4 w-1/2 h-1/2 bg-cyan-600/30 rounded-full blur-3xl animate-pulse delay-1000"></div>

            <div className="container mx-auto px-6 text-center z-10">
                <motion.h1
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: 'easeOut' }}
                    className="text-4xl md:text-6xl font-extrabold text-white leading-tight"
                >
                    The Ultimate Jupyter & Python <br />
                    <span className="text-cyan-400">Editor, Compiler & Viewer</span>
                </motion.h1>
                <motion.p
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
                    className="mt-6 text-lg md:text-xl text-gray-300 max-w-2xl mx-auto"
                >
                    <span className="block text-cyan-400 font-bold mb-2"></span>
                    Bring your entire data science workflow to your pocket. Run code, analyze data, and build models offline.
                </motion.p>
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.7, delay: 0.4, ease: 'easeOut' }}
                    className="mt-12 flex flex-col sm:flex-row justify-center items-center gap-4"
                >
                    <a
                        href="/NoteView v2.0.apk"
                        download="NoteView v2.0.apk"
                        onClick={() => trackDownload('Hero Section')}
                        className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-bold py-3 px-8 rounded-lg w-full sm:w-auto hover:scale-105 transform transition-transform duration-300"
                    >
                        Download APK
                    </a>
                    <button
                        onClick={scrollToFeatures}
                        className="border-2 border-cyan-400 text-cyan-400 font-bold py-3 px-8 rounded-lg w-full sm:w-auto hover:bg-cyan-400 hover:text-black transition-colors duration-300"
                    >
                        Learn More
                    </button>
                </motion.div>
                {/* Removed hero badge per request */}
                <motion.a
                    href="https://www.producthunt.com/products/noteview/launches/noteview" // Link to your Product Hunt page
                    target="_blank"
                    rel="noopener noreferrer"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.8 }}
                    className="mt-12 inline-flex items-center gap-3 rounded-lg bg-black/50 border border-gray-800 px-4 py-2 shadow-lg backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:bg-gray-900/70 hover:border-gray-600"
                >
                    <ProductHuntIcon className="h-10 w-10" />
                    <div className="text-left">
                        <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400">Featured On</p>
                        <p className="text-lg font-bold text-white">Product Hunt</p>
                    </div>
                    <div className="ml-4 border-l border-gray-700 pl-4 text-center">
                        <UpvoteArrowIcon className="h-5 w-5 mx-auto text-[#DA552F]" />
                        <p className="text-md font-bold text-white">13</p>
                    </div>
                </motion.a>
            </div>
        </section>
    );
};

const FeatureDetail = ({ icon, title, description }) => (
    <li className="flex items-start space-x-4">
        <div className="flex-shrink-0 mt-1 h-8 w-8 rounded-full backdrop-blur-md bg-white/5 border border-white/10 flex items-center justify-center">
            {icon}
        </div>
        <div>
            <h4 className="font-bold text-lg text-white">{title}</h4>
            <p className="text-gray-400">{description}</p>
        </div>
    </li>
);

const FeaturesSection = () => {
    return (
        <section id="features" className="py-20 bg-black relative overflow-hidden">
            {/* Ambient Background Blobs */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
                <div className="absolute top-1/4 -left-64 w-96 h-96 bg-purple-500/10 rounded-full blur-[100px]"></div>
                <div className="absolute bottom-1/4 -right-64 w-96 h-96 bg-cyan-500/10 rounded-full blur-[100px]"></div>
            </div>
            <div className="container mx-auto px-6 relative z-10">
                <div className="text-center mb-20">
                    <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-4">
                        An Unparalleled Mobile Experience
                    </h2>
                    <p className="text-center text-gray-400 max-w-2xl mx-auto">
                        From viewing complex notebooks to getting instant AI insights, NoteView is built to be your perfect mobile coding companion.
                    </p>
                </div>

                {/* Feature 1: Run & Execute Code Cells */}
                <motion.div
                    className="flex flex-col md:flex-row items-center gap-12 mb-24"
                    variants={sectionVariant}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                >
                    <div className="w-full md:w-1/2 flex justify-center">
                        <img src="/first.jpeg" alt="Local Kernel Execution" className="rounded-xl shadow-lg shadow-cyan-500/20 max-h-[600px]" />
                    </div>
                    <div className="w-full md:w-1/2">
                        <div className="inline-block bg-cyan-500/10 rounded-full px-4 py-1 mb-4">
                            <span className="text-cyan-400 font-bold text-sm tracking-wider">NEW FEATURE</span>
                        </div>
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">Run & Execute Code Cells</h3>
                        <ul className="space-y-6">
                            <FeatureDetail
                                icon={<TerminalIcon className="w-5 h-5 text-cyan-400" />}
                                title="Local Kernel Execution"
                                description="Run Python code cells inside your Jupyter Notebooks just like on a PC. True offline execution."
                            />
                            <FeatureDetail
                                icon={<SparklesIcon className="w-5 h-5 text-cyan-400" />}
                                title="Data Science Ready"
                                description="Built-in support for NumPy, Pandas, and Scikit-learn. Upload CSV datasets and analyze data on the go."
                            />
                            <FeatureDetail
                                icon={<WarningIcon className="w-5 h-5 text-cyan-400" />}
                                title="Full Kernel Control"
                                description="Start, Stop, and Reset the kernel instantly. Fix infinite loops or clear memory with one tap."
                            />
                        </ul>
                    </div>
                </motion.div>

                {/* Feature 2: Python Compiler */}
                <motion.div
                    className="flex flex-col md:flex-row-reverse items-center gap-12 mb-24"
                    variants={sectionVariant}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                >
                    <div className="w-full md:w-1/2 flex justify-center">
                        <img src="/smart.jpeg" alt="Python Compiler" className="rounded-xl shadow-lg shadow-purple-500/20 max-h-[600px]" />
                    </div>
                    <div className="w-full md:w-1/2">
                        <div className="inline-block bg-purple-500/10 rounded-full px-4 py-1 mb-4">
                            <span className="text-purple-400 font-bold text-sm tracking-wider">NEW FEATURE</span>
                        </div>
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">Python Compiler & Autocomplete</h3>
                        <ul className="space-y-6">
                            <FeatureDetail
                                icon={<TerminalIcon className="w-5 h-5 text-cyan-400" />}
                                title="Run Python Scripts"
                                description="A fast, efficient offline Python compiler to execute .py files instantly."
                            />
                            <FeatureDetail
                                icon={<SearchIcon className="w-5 h-5 text-cyan-400" />}
                                title="Smart Coding"
                                description="Code faster with Jedi Autocomplete and a new, beautiful coding font designed for readability."
                            />
                            <FeatureDetail
                                icon={<FileIcon className="w-5 h-5 text-cyan-400" />}
                                title="Create & Edit"
                                description="Start new projects, manage code snippets with the new Snippet Manager, and edit files with ease."
                            />
                        </ul>
                    </div>
                </motion.div>

                {/* Feature 3: AI Assistant */}
                <motion.div
                    className="flex flex-col md:flex-row items-center gap-12"
                    variants={sectionVariant}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                >
                    <div className="w-full md:w-1/2 flex justify-center">
                        <img src="/ai.jpeg" alt="AI Assistant" className="rounded-xl shadow-lg shadow-pink-500/20 max-h-[600px]" />
                    </div>
                    <div className="w-full md:w-1/2">
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">AI-Powered Assistance</h3>
                        <ul className="space-y-6">
                            <FeatureDetail
                                icon={<ShieldIcon className="w-5 h-5 text-cyan-400" />}
                                title="Two Powerful Models"
                                description="Switch between Llama 3.3 (70B) for in-depth explanations and Llama 3.1 (8B) for speed."
                            />
                            <FeatureDetail
                                icon={<ChatIcon className="w-5 h-5 text-cyan-400" />}
                                title="Code Insights"
                                description="Ask the AI to debug errors, explain complex logic, or summarize entire notebooks."
                            />
                            <FeatureDetail
                                icon={<ExportIcon className="w-5 h-5 text-cyan-400" />}
                                title="PDF Export & Sharing"
                                description="Share professional PDF versions of your notebooks and scripts with classmates or colleagues."
                            />
                        </ul>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

const WhyChooseSection = () => (
    <motion.section
        className="py-20 bg-black relative"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
    >
        {/* Ambient background blob for glass effect */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-cyan-900/20 rounded-full blur-[100px] -z-10"></div>

        <div className="container mx-auto px-6">
            <div className="backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl p-8 md:p-12 relative overflow-hidden shadow-2xl">
                <div className="absolute top-0 right-0 w-64 h-64 bg-cyan-600/10 rounded-full blur-3xl -mr-32 -mt-32"></div>

                <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
                    <div className="w-full md:w-1/2">
                        <h2 className="text-3xl font-bold text-white mb-4">
                            Why Choose NoteView?
                        </h2>
                        <p className="text-xl text-gray-300 mb-6 font-medium">
                            Most apps only let you <span className="text-red-400 line-through decoration-2">read</span> notebooks.
                            <br />
                            NoteView lets you <span className="text-cyan-400 font-bold">RUN</span> them.
                        </p>
                        <p className="text-gray-400">
                            Stop limiting your potential. Upgrade to the only Android app that offers a true desktop-class data science environment in your pocket.
                        </p>
                    </div>
                    <div className="w-full md:w-1/2">
                        <ul className="space-y-4">
                            <li className="flex items-center backdrop-blur-md bg-white/5 p-4 rounded-lg border border-white/10 hover:bg-white/10 transition-colors duration-300">
                                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clipRule="evenodd" /></svg>
                                </span>
                                <span className="text-white font-medium">Train simple ML models with Scikit-learn</span>
                            </li>
                            <li className="flex items-center backdrop-blur-md bg-white/5 p-4 rounded-lg border border-white/10 hover:bg-white/10 transition-colors duration-300">
                                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clipRule="evenodd" /></svg>
                                </span>
                                <span className="text-white font-medium">Analyze CSV data with Pandas</span>
                            </li>
                            <li className="flex items-center backdrop-blur-md bg-white/5 p-4 rounded-lg border border-white/10 hover:bg-white/10 transition-colors duration-300">
                                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clipRule="evenodd" /></svg>
                                </span>
                                <span className="text-white font-medium">Visualize data with Matplotlib</span>
                            </li>
                            <li className="flex items-center backdrop-blur-md bg-white/5 p-4 rounded-lg border border-white/10 hover:bg-white/10 transition-colors duration-300">
                                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clipRule="evenodd" /></svg>
                                </span>
                                <span className="text-white font-medium">Edit and fix code bugs immediately</span>
                            </li>
                            <li className="flex items-center backdrop-blur-md bg-white/5 p-4 rounded-lg border border-white/10 hover:bg-white/10 transition-colors duration-300">
                                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 text-green-400 flex items-center justify-center mr-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z" clipRule="evenodd" /></svg>
                                </span>
                                <span className="text-white font-medium">Learn faster with AI explanations</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </motion.section>
);

const WhatsNewSection = () => (
    <motion.section
        className="py-20 bg-black relative"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
    >
        <div className="absolute inset-0 bg-grid-white/5 [mask-image:linear-gradient(to_bottom,transparent,black,transparent)] pointer-events-none"></div>

        <div className="container mx-auto px-6 flex flex-wrap-reverse md:flex-wrap items-center justify-center gap-10">
            <div className="w-full md:w-1/2 lg:w-2/5">
                <span className="text-cyan-400 font-semibold">VERSION 2.0</span>
                <h2 className="text-3xl md:text-4xl font-bold text-white mt-2 mb-4">The Execution Update</h2>
                <p className="text-gray-400 mb-8">
                    NoteView evolves into a true mobile IDE. Execute code, analyze data, and build models offline with our biggest update ever.
                </p>
                <ul className="space-y-4">
                    <li className="flex items-start">
                        <span className="text-cyan-400 text-xl mr-3 mt-1">✓</span>
                        <div>
                            <h4 className="font-bold text-white">Run Locally</h4>
                            <p className="text-gray-400 text-sm">Execute Jupyter cells & Python scripts offline.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-cyan-400 text-xl mr-3 mt-1">✓</span>
                        <div>
                            <h4 className="font-bold text-white">ML Ready</h4>
                            <p className="text-gray-400 text-sm">Built-in support for NumPy, Pandas, & Scikit-learn.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-cyan-400 text-xl mr-3 mt-1">✓</span>
                        <div>
                            <h4 className="font-bold text-white">Full Control</h4>
                            <p className="text-gray-400 text-sm">Start, Stop, and Reset kernels instantly.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-cyan-400 text-xl mr-3 mt-1">✓</span>
                        <div>
                            <h4 className="font-bold text-white">Create & Edit</h4>
                            <p className="text-gray-400 text-sm">Start new projects + new Snippet Manager.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-cyan-400 text-xl mr-3 mt-1">✓</span>
                        <div>
                            <h4 className="font-bold text-white">Smart Coding</h4>
                            <p className="text-gray-400 text-sm">Added Jedi Autocomplete & new coding font.</p>
                        </div>
                    </li>
                    <li className="flex items-start">
                        <span className="text-cyan-400 text-xl mr-3 mt-1">✓</span>
                        <div>
                            <h4 className="font-bold text-white">Data Tools</h4>
                            <p className="text-gray-400 text-sm">Upload CSV datasets & enhanced PDF export.</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="w-full md:w-1/2 lg:w-2/5 flex justify-center">
                <img src="/start.jpeg" alt="What's New v1.2" className="rounded-xl shadow-lg shadow-cyan-500/20 max-h-[600px]" />
            </div>
        </div>
    </motion.section>
);

const ScreenshotsSection = () => {
    const screenshots = [
        "/data.jpeg",
        "/ai.jpeg",
        "/first.jpeg",
        "/kernel.jpeg",
        "/smart.jpeg",
        "/start.jpeg",
        "/terminal.jpeg",
        "/train.jpeg",
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    const prevSlide = () => {
        const isFirstSlide = currentIndex === 0;
        const newIndex = isFirstSlide ? screenshots.length - 1 : currentIndex - 1;
        setCurrentIndex(newIndex);
    };

    const nextSlide = () => {
        const isLastSlide = currentIndex === screenshots.length - 1;
        const newIndex = isLastSlide ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };

    return (
        <motion.section
            className="py-20 bg-gray-950"
            variants={sectionVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
        >
            <div className="container mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
                    See It In Action
                </h2>
                <div className="relative max-w-xs mx-auto h-[500px] group">
                    <AnimatePresence initial={false}>
                        <motion.img
                            key={currentIndex}
                            src={screenshots[currentIndex]}
                            alt={`App screenshot ${currentIndex + 1}`}
                            className="w-full h-full object-contain rounded-2xl absolute"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -50 }}
                            transition={{ duration: 0.4, ease: 'easeInOut' }}
                        />
                    </AnimatePresence>

                    {/* Left Arrow */}
                    <button onClick={prevSlide} className="absolute top-1/2 -translate-y-1/2 -left-10 md:-left-16 text-white/50 hover:text-white transition-colors duration-300 opacity-0 group-hover:opacity-100">
                        <ChevronLeftIcon className="w-10 h-10" />
                    </button>
                    {/* Right Arrow */}
                    <button onClick={nextSlide} className="absolute top-1/2 -translate-y-1/2 -right-10 md:-right-16 text-white/50 hover:text-white transition-colors duration-300 opacity-0 group-hover:opacity-100">
                        <ChevronRightIcon className="w-10 h-10" />
                    </button>
                </div>
                <div className="flex justify-center mt-6 space-x-2">
                    {screenshots.map((_, index) => (
                        <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-colors duration-300 ${currentIndex === index ? 'bg-cyan-400' : 'bg-gray-600'}`}></button>
                    ))}
                </div>
            </div>
        </motion.section>
    );
};

const AboutSection = () => (
    <motion.section
        id="about"
        className="py-20 bg-black"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
    >
        <div className="container mx-auto px-6 text-center max-w-3xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">About NoteView</h2>
            <p className="text-gray-400 text-lg">
                NoteView started with a simple mission: to view Jupyter Notebooks on the go. Today, it has evolved into a complete <span className="text-cyan-400 font-bold">Mobile Data Science Environment</span>. We're not just a viewer anymore—we are the first Android app that lets you <strong className="text-white">run, edit, and create</strong> Jupyter Notebooks and Python code entirely offline. Whether you're a student learning to code or a data scientist testing models on the go, NoteView puts the power of a desktop IDE in your pocket.
            </p>
        </div>
    </motion.section>
);

const FaqItem = ({ question, answer }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="border-b border-gray-800">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="w-full flex justify-between items-center text-left py-5 px-2"
            >
                <span className="text-lg font-medium text-white">{question}</span>
                <motion.div animate={{ rotate: isOpen ? 45 : 0 }}>
                    {isOpen ? <MinusIcon className="w-6 h-6 text-cyan-400" /> : <PlusIcon className="w-6 h-6 text-cyan-400" />}
                </motion.div>
            </button>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                        className="overflow-hidden"
                    >
                        <p className="text-gray-400 pb-5 px-2">{answer}</p>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

const FaqSection = () => {
    const faqs = [
        {
            question: "Can I edit my files in the app?",
            answer: "Yes! You can fully create and edit both Python scripts (.py) and Jupyter Notebooks (.ipynb). You can run code cells, add new cells, and manage your entire project locally."
        },
        {
            question: "Is NoteView free to use?",
            answer: "Yes, the core features of NoteView, including viewing, editing, and local execution, are completely free. The AI-powered features use free APIs and have reasonable usage limits."
        },
        {
            question: "Which AI models can I use?",
            answer: "You can choose between two powerful models: Llama 3.3 (70B) for versatile, strong explanations, and Llama 3.1 (8B) for lightweight, efficient analysis. You can switch between them freely in the settings."
        },
        {
            question: "How do I open files in the app?",
            answer: "Simply open a .ipynb or .py file from any app on your phone (like Gmail, WhatsApp, or your File Manager) and choose NoteView when prompted. The app will handle it smoothly."
        },
        {
            question: "Can I change the theme?",
            answer: "Absolutely. You can choose between System Default, a dedicated Light mode, or a Dark mode to match your preference and reduce eye strain."
        },
        {
            question: "Does the app handle large notebooks?",
            answer: "Yes, the app is performance-optimized for smooth scrolling and fast rendering, even with large and complex notebook files."
        },
        {
            question: "Is my code secure?",
            answer: "We take your privacy and security very seriously. Local execution runs entirely offline on your device. AI processing sends snippets to secure cloud APIs only when you explicitly ask."
        },
        {
            question: "What's next for NoteView?",
            answer: "We are always working on improvements! We're planning to add more libraries, improved graphing tools, and cloud sync features. Stay tuned!"
        }
    ];

    return (
        <motion.section
            id="faq"
            className="py-20 bg-gray-950 relative overflow-hidden"
            variants={sectionVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
        >
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-900/10 rounded-full blur-[120px] pointer-events-none"></div>
            <div className="container mx-auto px-6 max-w-3xl">
                <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12">
                    Frequently Asked Questions
                </h2>
                <div className="space-y-2">
                    {faqs.map((faq, i) => (
                        <FaqItem key={i} question={faq.question} answer={faq.answer} />
                    ))}
                </div>
            </div>
        </motion.section>
    );
};


const DownloadSection = () => (
    <motion.section
        className="py-20 bg-black relative"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
    >
        <div className="absolute inset-0 bg-grid-cyan-500/10 [mask-image:linear-gradient(to_bottom,white,transparent)]"></div>
        <div className="container mx-auto px-6 text-center relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Get Started Today</h2>
            <p className="text-gray-400 mb-8 max-w-xl mx-auto">
                Download NoteView now and revolutionize the way you interact with code on your Android device.
            </p>
            <a
                href="https://github.com/Aakhilshaik204/noteviewai/releases/download/NoteView/NoteView.2.0.apk"
                onClick={() => trackDownload('Download Section')}
                className="inline-block bg-gradient-to-r from-blue-500 via-purple-500 to-cyan-500 text-white font-bold py-4 px-10 rounded-lg text-lg hover:scale-105 transform transition-transform duration-300 shadow-lg shadow-cyan-500/30"
            >
                Download APK
            </a>
        </div>
    </motion.section>
);

const IdeasContactSection = () => (
    <motion.section
        className="py-20 bg-gray-950"
        variants={sectionVariant}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
    >
        <div className="container mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Have an Idea or a Question?</h2>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
                NoteView is a project driven by the community. If you have a feature request, a suggestion, or just want to say hello, I'd love to hear from you.
            </p>
            <a
                href="mailto:aakhilshaik204@gmail.com"
                className="inline-flex items-center gap-3 bg-cyan-500/10 border border-cyan-500/30 text-cyan-300 font-bold py-3 px-8 rounded-lg hover:bg-cyan-500/20 transition-colors duration-300"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>Get in Touch</span>
            </a>
        </div>
    </motion.section>
);


const Footer = ({ onShowPrivacy }) => (
    <footer className="bg-gray-950 text-gray-400">
        <div className="container mx-auto px-6 py-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
                <div className="mb-4 md:mb-0">
                    <h3 className="text-xl font-bold text-white">NoteView</h3>
                    <p className="text-sm">© {new Date().getFullYear()} NoteView. All rights reserved.</p>
                </div>
                <div className="flex items-center space-x-6">
                    <button onClick={onShowPrivacy} className="hover:text-cyan-400 transition-colors duration-300">Privacy Policy</button>
                    <a href="mailto:aakhilshaik204@gmail.com" className="hover:text-cyan-400 transition-colors duration-300">Contact</a>
                    <a href="https://play.google.com/store/apps/details?id=ai.noteview.app&hl=en" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-bold py-2 px-5 rounded-lg border border-white/20 bg-white/10 text-white hover:bg-white/20 transition-colors duration-300">
                        <GooglePlayIcon className="h-4 w-4" />
                        Play Store
                    </a>
                </div>
            </div>
        </div>
    </footer>
);

const PrivacyPolicyPage = ({ onBack }) => (
    <div className="bg-black text-gray-300 min-h-screen">
        <div className="container mx-auto px-6 py-12 max-w-4xl">
            <header className="mb-12">
                <h1 className="text-4xl font-extrabold text-white">NoteView</h1>
                <p className="text-xl text-gray-400">Privacy Policy</p>
            </header>

            <main className="space-y-8">
                <div>
                    <h2 className="text-2xl font-bold text-white mb-2">Our Commitment to Your Privacy</h2>
                    <p><strong>Effective Date:</strong> August 15, 2025</p>
                    <p className="mt-2">
                        Your privacy and security are the top priorities for NoteView. This app was designed from the ground up to be a secure, private tool. We do not collect, store, or share any of your personal information or data from your files.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-bold text-white mb-2">Information We Do Not Collect</h2>
                    <p>
                        NoteView does not collect, transmit, or store any personal data. This includes:
                    </p>
                    <ul className="list-disc list-inside mt-2 space-y-1 pl-4">
                        <li>Your name, email address, or contact information.</li>
                        <li>The content of your `.ipynb` or `.py` files.</li>
                        <li>Usage data, analytics, or crash reports.</li>
                        <li>Any identifiers from your device.</li>
                    </ul>
                    <p className="mt-2">
                        All file processing happens locally on your device. Your files are your own and never leave your phone unless you explicitly choose to share or export them.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-bold text-white mb-2">AI Features & Data Security</h2>
                    <p>
                        When you use the AI-powered features (like code explanation or summarization), the selected code snippet is sent to a secure, third-party API (Llama or Gemma) for processing.
                    </p>
                    <ul className="list-disc list-inside mt-2 space-y-1 pl-4">
                        <li>The data is sent securely over HTTPS.</li>
                        <li>The data is not stored or used to train the AI models.</li>
                        <li>No personal information is sent along with the code.</li>
                    </ul>
                    <p className="mt-2">
                        We ensure that your interaction with the AI is private and poses no threat to your data's confidentiality.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-bold text-white mb-2">A Secure App with No Threats</h2>
                    <p>
                        NoteView is built to be a safe and reliable tool. There are no trackers, no advertisements, and no hidden data collection. You can use the app with full confidence that your information remains private and secure.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-bold text-white mb-2">Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, please feel free to contact us at <a href="mailto:aakhilshaik204@gmail.com" className="text-cyan-400 hover:underline">aakhilshaik204@gmail.com</a>.
                    </p>
                </div>

                <div className="pt-8">
                    <button onClick={onBack} className="text-cyan-400 hover:text-cyan-300 transition-colors duration-300">&larr; Back to Home</button>
                </div>
            </main>
        </div>
    </div>
);


// --- Main App Component ---
export default function App() {
    const [currentPage, setCurrentPage] = useState('main');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPage]);

    if (currentPage === 'privacy') {
        return <PrivacyPolicyPage onBack={() => setCurrentPage('main')} />;
    }

    return (
        <div className="bg-black font-sans">
            <Header />
            <main>
                <HeroSection />
                <FeaturesSection />
                <WhyChooseSection />
                <WhatsNewSection />
                <ScreenshotsSection />
                <AboutSection />
                <FaqSection />
                <DownloadSection />
                <IdeasContactSection />
            </main>
            <Footer onShowPrivacy={() => setCurrentPage('privacy')} />
        </div>
    );
}
